import { createApiActions } from '@app/shared/store/standard.actions';
import { ShadowUpdateAccepted, ThingDocument, ThingShadow } from '@cco/model';
import { createAction, props } from '@ngrx/store';

export const upsertThing = createAction(
  '[IoT Thing] UPSERT_THING',
  props<{ thing: ThingDocument }>(),
);
export const upsertThings = createAction(
  '[IoT Thing] UPSERT_THINGS',
  props<{ things: ThingDocument[] }>(),
);
export const {
  baseAction: getThingShadow,
  successAction: getThingShadowSuccess,
} = createApiActions(
  '[IoT Thing] GET_THING_SHADOW',
  props<{ requestId?: string; assetType: string; assetUuid: string; thingName: string }>(),
  props<{
    requestId?: string;
    thingName: string;
    // -eslint-disable-next-line @typescript-eslint/ban-types
    thingShadow: ThingShadow<object>;
  }>(),
);
// Carries the thing name so the failure can be reported against that thing.
export const getThingShadowFailure = createAction(
  '[IoT Thing] GET_THING_SHADOW_FAILURE',
  props<{ requestId?: string; thingName: string; error: any }>(),
);
export const patchThingShadow = createAction(
  '[IoT Thing] PATCH_THING_SHADOW',
  props<{
    requestId?: string;
    thingName: string;
    // -eslint-disable-next-line @typescript-eslint/ban-types
    shadowUpdateAccepted: ShadowUpdateAccepted<object>;
  }>(),
);
export const upsertThingShadow = createAction(
  '[IoT Thing] UPSERT_THING_SHADOW',
  // -eslint-disable-next-line @typescript-eslint/ban-types
  props<{ requestId?: string; thingName: string; shadow: ThingShadow<object> }>(),
);
export const getThingShadows = createAction(
  '[IoT Thing] GET_THING_SHADOWS',
  props<{ requestId?: string; assetType: string; assetUuid: string; thingNames: string[] }>(),
);
export const getThingShadowsFailure = createAction(
  '[IoT Thing] GET_THING_SHADOWS_FAILURE',
  props<{ requestId?: string; thingNames: string[]; error: any }>(),
);
